/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import siteMessage from "@insite/client-framework/SiteMessage";

export const validateAlphanumericNumbers = (number: string) => {
    const alphanumericRegexp = /^[a-zA-Z0-9_-\s]*$/;
    let error = siteMessage("Custom_OnlyAlphaNumericAllowed");

    if (!number) {
        return error;
    }

    const m = alphanumericRegexp.exec(number);

    if (m !== null) {
        m.forEach((match, groupIndex) => {
            error = "";
        });
    }

    return error;
};

export const validateEmail = (email: string) => {
    const emailRegexp = new RegExp("\\w+([-+.']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*");

    return emailRegexp.test(email) ? "" : siteMessage("Custom_EmailIsNotValid");
};


export const formatPhoneNumber = (value: string, customMxValidation = false) => {
    const phoneNumber = value.replace(/\D/g, "");
    const phoneNumberLength = phoneNumber.length;

    if (phoneNumberLength < 4) {
        return phoneNumber;
    }

    if (phoneNumberLength < 7) {
        return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    }

    if (phoneNumberLength < 11) {
        return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
    }

    if (customMxValidation) {
        return `${phoneNumber.slice(0, 2)} ${phoneNumber.slice(2, 4)} ${phoneNumber.slice(4, 8)} ${phoneNumber.slice(8, 12)}`;
    } 
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
};

export const validateAddress = (address: string, allowedSpecialChar: string) => {
    let error = siteMessage("Custom_AddressValidationInput");
    let addressRegexp = new RegExp("");
    const isDashExist = allowedSpecialChar.indexOf("-") === -1;

    if(isDashExist){
        addressRegexp = new RegExp(`^[a-zA-Z0-9${allowedSpecialChar}]*$`);
    }
    else {
        allowedSpecialChar = allowedSpecialChar.replace('-','');
        addressRegexp = new RegExp(`^[a-zA-Z0-9${allowedSpecialChar}-]*$`);
    }
    

    if (!address) {
        return error;
    }

    const m = addressRegexp.exec(address);

    if (m !== null) {
        m.forEach((match, groupIndex) => {
            error = "";
        });
    }

    return error;
};
